module.exports = {
  footerText: `© ${new Date().getFullYear()} All Rights Reserved `,
  footerLink: {
    text: 'Janus Infratech Private Limited',
    href: 'https://www.janusinfratech.com',
    target: '_blank',
    rel: 'noopener noreferrer'  // Adding security best practice
  }
}
